module.exports = __webpack_public_path__ + "static/media/maintenance.65cbf1e8.svg";